import {
  Component,
  Input,
  OnInit,
  Output,
  AfterViewInit,
  QueryList,
  ViewChildren,
  Renderer2,
  ElementRef,
  EventEmitter,
} from '@angular/core';
import { ProductTimeSpanComponent } from '../product-time-span/product-time-span.component';
import { ProductTimeSpan } from '../../models/product-time-span';

@Component({
  selector: 'app-product-time-spans',
  templateUrl: 'product-time-spans.component.html',
  styleUrls: ['product-time-spans.component.scss']
})
export class ProductTimeSpansComponent implements OnInit, AfterViewInit {
  @Input() productTimeSpans: ProductTimeSpan[];
  @Input() selectedProductTimeSpan: ProductTimeSpan;
  @ViewChildren(ProductTimeSpanComponent) timeSpanComponents: QueryList<ProductTimeSpanComponent>;
  @Output() selectionChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngAfterViewInit() {
    if (this.productTimeSpans == null || !this.productTimeSpans.length) {
      return;
    }

    let selectedIndex = 0;
    if (this.selectedProductTimeSpan != null) {
      const tss = this.productTimeSpans.filter(x => x.timeSpan === this.selectedProductTimeSpan.timeSpan);
      if (tss.length > 0) {
        selectedIndex = this.productTimeSpans.indexOf(tss[0]);
        this.selectedProductTimeSpan = this.productTimeSpans[selectedIndex];
      }
    }
  }

  ngOnInit() {
  }

  onClick(productTimeSpan: ProductTimeSpan) {
    this.selectedProductTimeSpan = productTimeSpan;
    this.selectionChanged.emit(productTimeSpan);
  }

  isProductTimeSpanSelected(productTimeSpan: ProductTimeSpan): boolean {
    return productTimeSpan === this.selectedProductTimeSpan;
  }
}
